import { render, staticRenderFns } from "./BackBarDefaultItem.vue?vue&type=template&id=1b61b72e&scoped=true"
import script from "./BackBarDefaultItem.vue?vue&type=script&lang=ts"
export * from "./BackBarDefaultItem.vue?vue&type=script&lang=ts"
import style0 from "./BackBarDefaultItem.vue?vue&type=style&index=0&id=1b61b72e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b61b72e",
  null
  
)

export default component.exports